var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeaMonster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m333.846 476.267c-6.143 0-12.284-2.343-16.971-7.029-9.372-9.373-9.372-24.569 0-33.941l74.544-74.544c11.883-11.882 18.427-27.681 18.427-44.485s-6.544-32.603-18.426-44.484l-27.918-27.917c-19.124-19.125-29.656-44.552-29.656-71.598 0-27.045 10.532-52.472 29.656-71.597l9.374-9.374c9.372-9.372 24.568-9.372 33.94.001 9.373 9.373 9.372 24.569-.001 33.941l-9.373 9.373c-10.058 10.058-15.597 23.432-15.597 37.656 0 14.225 5.539 27.599 15.598 37.657l27.917 27.917c20.948 20.947 32.485 48.8 32.485 78.426s-11.537 57.479-32.485 78.427l-74.544 74.544c-4.686 4.683-10.827 7.027-16.97 7.027z",
    fill: "#147864"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m176.513 476.267c-6.142 0-12.284-2.343-16.971-7.029l-74.544-74.544c-20.948-20.949-32.485-48.801-32.485-78.427s11.537-57.479 32.486-78.426l27.916-27.917c10.059-10.059 15.598-23.432 15.598-37.657s-5.54-27.599-15.598-37.657l-9.373-9.373c-9.373-9.373-9.373-24.569 0-33.941s24.568-9.372 33.941 0l9.373 9.373c19.125 19.125 29.657 44.552 29.657 71.598 0 27.047-10.533 52.474-29.657 71.598l-27.916 27.917c-11.883 11.883-18.427 27.681-18.427 44.485s6.544 32.603 18.427 44.485l74.544 74.544c9.373 9.373 9.373 24.569 0 33.941-4.687 4.686-10.829 7.03-16.971 7.03z",
    fill: "#147864"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m381.846 289.6c0-71.899-59.28-129.952-131.631-127.95-69.576 1.926-124.384 58.376-124.369 127.978.009 40.195 18.546 76.059 47.535 99.519 10.372 8.394 16.465 20.967 16.465 34.31v74.143h128v-74.138c0-13.202 5.862-25.788 16.151-34.061 29.176-23.461 47.849-59.449 47.849-99.801z",
    fill: "#7dc8aa"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 317.846,
    cy: 417.6,
    fill: "#faa51e",
    r: 32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 189.846,
    cy: 417.6,
    fill: "#faa51e",
    r: 32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m189.846 433.6c-4.418 0-8-3.582-8-8v-16c0-4.418 3.582-8 8-8 4.418 0 8 3.582 8 8v16c0 4.418-3.581 8-8 8z",
    fill: "#464646"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m317.846 433.6c-4.418 0-8-3.582-8-8v-16c0-4.418 3.582-8 8-8 4.418 0 8 3.582 8 8v16c0 4.418-3.581 8-8 8z",
    fill: "#464646"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m441.693 441.6c-2.091 0-3.806 1.562-4.119 3.63-1.75 11.532-11.706 20.37-23.727 20.37s-21.978-8.838-23.727-20.37c-.314-2.068-2.028-3.63-4.119-3.63h-8.307c-2.091 0-3.806 1.562-4.119 3.63-1.75 11.532-11.706 20.37-23.727 20.37s-21.978-8.838-23.727-20.37c-.314-2.068-2.028-3.63-4.119-3.63h-8.307c-2.091 0-3.806 1.562-4.119 3.63-1.75 11.532-11.706 20.37-23.727 20.37s-21.978-8.838-23.727-20.37c-.314-2.068-2.028-3.63-4.119-3.63h-8.307c-2.091 0-3.806 1.562-4.119 3.63-1.75 11.532-11.706 20.37-23.727 20.37s-21.978-8.838-23.727-20.37c-.314-2.068-2.028-3.63-4.119-3.63h-8.307c-2.091 0-3.806 1.562-4.119 3.63-1.75 11.532-11.706 20.37-23.727 20.37s-21.978-8.838-23.727-20.37c-.314-2.068-2.028-3.63-4.119-3.63h-8.307c-2.091 0-3.806 1.562-4.119 3.63-1.75 11.532-11.706 20.37-23.727 20.37s-21.978-8.838-23.727-20.37c-.314-2.068-2.028-3.63-4.119-3.63h-4.153v56h384v-56z",
    fill: "#6ea5d7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 301.846,
    cy: 297.6,
    fill: "#329682",
    r: 24
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 221.846,
    cy: 241.6,
    fill: "#329682",
    r: 16
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 237.846,
    cy: 353.6,
    fill: "#329682",
    r: 8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m333.846 113.6h-35.056c-3.03 0-5.8 1.712-7.155 4.422l-3.578 7.155c-1.355 2.71-4.125 4.422-7.155 4.422h-54.112c-3.03 0-5.8-1.712-7.155-4.422l-3.578-7.155c-1.355-2.71-4.125-4.422-7.155-4.422h-35.056c-4.418 0-8 3.582-8 8v8c0 26.51 21.49 48 48 48h112c8.837 0 16-7.163 16-16v-40c0-4.418-3.582-8-8-8z",
    fill: "#faa51e"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m168.588 145.6c6.591 18.641 24.36 32 45.258 32h112c8.837 0 16-7.164 16-16v-16z",
    fill: "#d76e28"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m245.846 41.6h16v88h-16z",
    fill: "#d76e28"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m272.297 17.6h-36.901c-2.73 0-4.658 2.675-3.795 5.265l4.422 13.265c1.089 3.267 4.146 5.47 7.589 5.47h20.468c3.443 0 6.501-2.203 7.589-5.47l4.422-13.265c.864-2.59-1.064-5.265-3.794-5.265z",
    fill: "#d76e28"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m309.846 105.6h-96l-4.686-4.686c-7.244-7.244-11.314-17.069-11.314-27.314 0-10.245 4.07-20.07 11.314-27.314l4.686-4.686h96l-4.686 4.686c-7.244 7.244-11.314 17.069-11.314 27.314 0 10.245 4.07 20.07 11.314 27.314z",
    fill: "#fab991"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeaMonster);
export default __webpack_public_path__ + "static/media/sea-monster.16944ec581fd73eb72d96ea662a98836.svg";
export { ForwardRef as ReactComponent };